import axios from '../utils/axios';

export const create = (user_id, value) => {
  return axios.post(`userActions/money/${user_id}/gift`, { action_value: value });
};